module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Step 4/5")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.uploadedImgUrl),
      expression: "uploadedImgUrl"
    }],
    attrs: {
      "height": "100",
      "width": "100"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n\n    from previous route => " + _vm._s(_vm.$route.query) + " "), _c('br'), _c('br'), _vm._v("\n    location from previous route [parsed] => " + _vm._s(JSON.parse(_vm.$route.query.shareSpotLocation)) + " "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.goTo_uploadImage_5({
          url: _vm.$route.query.url,
          resourceType: _vm.$route.query.resourceType,
          publicId: _vm.$route.query.publicId,
          //
          createdAt: _vm.$route.query.createdAt,
          //
          caption: _vm.$route.query.caption,
          emotionalAppeal: JSON.parse(_vm.$route.query.emotionalAppeal),
          //
          shareSpotLocation: JSON.parse(_vm.$route.query.shareSpotLocation), //parsed
          hasGeohash: _vm.$route.query.hasGeohash,
          //
          spotType: _vm.$store.state.uploadImage_4.selectedSpotType_uploadImage,
          anyoneCanVisitThisSpot: _vm.$store.state.uploadImage_4.anyoneCanVisitThisSpot_uploadImage
        })
      }
    }
  }, [_vm._v("\n      next\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20c7c2f3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uploadImage/uploadImage_4.vue
// module id = 833
// module chunks = 13